export const BISHOPRIC = ['BISHOP', 'BISHOPRIC_FIRST_COUNSELOR', 'BISHOPRIC_SECOND_COUNSELOR']

export const BRANCH_PRESIDENCY = [
  'BRANCH_PRESIDENT',
  'BRANCH_PRESIDENCY_FIRST_COUNSELOR',
  'BRANCH_PRESIDENCY_SECOND_COUNSELOR',
]

export const ELDERS_QUORUM_PRESIDENCY = [
  'ELDERS_QUORUM_PRESIDENT',
  'ELDERS_QUORUM_FIRST_COUNSELOR',
  'ELDERS_QUORUM_SECOND_COUNSELOR',
]

export const RELIEF_SOCIETY_PRESIDENCY = [
  'RELIEF_SOCIETY_PRESIDENT',
  'RELIEF_SOCIETY_FIRST_COUNSELOR',
  'RELIEF_SOCIETY_SECOND_COUNSELOR',
]

export const YOUNG_WOMENS_PRESIDENCY = [
  'YOUNG_WOMEN_PRESIDENT',
  'YOUNG_WOMEN_FIRST_COUNSELOR',
  'YOUNG_WOMEN_SECOND_COUNSELOR',
]

export const FAMILY_HISTORY = [
  'WARD_TEMPLE_AND_FAMILY_HISTORY_LEADER',
  'BRANCH_TEMPLE_AND_FAMILY_HISTORY_LEADER',
  'BRANCH_FAMILY_HISTORY_LEADER',
  'WARD_FAMILY_HISTORY_LEADER',
  'FAMILY_HISTORY_LEADER',
  'WARD_TEMPLE_AND_FAMILY_HISTORY_CONSULTANT',
  'BRANCH_TEMPLE_AND_FAMILY_HISTORY_CONSULTANT',
  'TEMPLE_AND_FAMILY_HISTORY_CONSULTANT',
]

export const simpleNameReasons = [
  'INVALID_TITLE_GIVEN_MISSING',
  'INVALID_GIVEN_NAME_PIECE',
  'INVALID_NAME',
  'INVALID_SURNAME',
  'INVALID_SPECIAL_CHARACTER_NAME',
  'INVALID_SINGLE_NAME_PIECE',
  'MISTER_AS_ONLY_SURNAME',
  'NAME_CONTAINS_ONLY_INITIALS',
  'NO_NAME',
  'NAME_LANG_UND_WITH_MULTIPLE_SCRIPTS',
  'NAME_LANG_SCRIPT_MISMATCH',
  'NAME_TOO_LONG',
  'ONE_LATIN_LETTER_SURNAME',
  'REPEATING_SPECIAL_CHARACTER_NAME',
]

export const availableLangsBishopVideo = [
  'de',
  'en',
  'es',
  'fj',
  'fr',
  'id',
  'it',
  'ja',
  'km',
  'ko',
  'mn',
  'nl',
  'no',
  'pt',
  'ru',
  'sm',
  'th',
  'tl',
  'to',
  'vi',
  'zh',
  'zh-hans',
]

// NOTE: FamilySearch uses BCP47 locale format; LCR/ICS uses IS0-639-3 locale format.
// Locales found here: https://churchofjesuschrist.sharepoint.com/sites/KnowledgeManagement/Lists/LanguageBookOPS/AllItems.aspx
export const mapFsToLcrLocales = {
  ar: 'ara', // Arabic
  bg: 'bul', // Bulgarian
  ceb: 'ceb', // Cebuano
  cs: 'ces', // Czech
  da: 'dan', // Danish
  de: 'deu', // German
  el: 'ell', // Greek
  en: 'eng', // English
  es: 'spa', // Spanish
  et: 'est', // Estonian
  fa: 'fas', // Persian
  fi: 'fin', // Finnish
  fj: 'fij', // Fijian
  fr: 'fra', // French
  gn: 'grn', // Guarani
  hr: 'hrv', // Croatian
  ht: 'hat', // Haitian Creole
  hu: 'hun', // Hungarian
  hy: 'hye', // Armenian
  id: 'ind', // Indonesian
  is: 'isl', // Icelandic
  it: 'ita', // Italian
  ja: 'jpn', // Japanese
  ka: 'kat', // Georgian
  km: 'khm', // Khmer
  ko: 'kor', // Korean
  lt: 'lit', // Lithuanian
  lv: 'lav', // Latvian
  mg: 'mlg', // Malagasy
  mk: 'mkd', // Macedonian
  mn: 'mon', // Mongolian
  ms: 'msa', // Malay
  nl: 'nld', // Dutch
  no: 'nor', // Norwegian
  pl: 'pol', // Polish
  pt: 'por', // Portuguese
  ro: 'ron', // Romanian
  ru: 'rus', // Russian
  sk: 'slk', // Slovak
  sl: 'slv', // Slovenian
  sm: 'smo', // Samoan
  sq: 'alb', // Albanian
  sr: 'srp', // Serbian
  sv: 'swe', // Swedish
  sw: 'swa', // Swahili
  th: 'tha', // Thai
  tl: 'tgl', // Tagalog
  to: 'ton', // Tongan
  tr: 'tur', // Turkish
  ty: 'tah', // Tahitian
  uk: 'ukr', // Ukrainian
  ur: 'urd', // Urdu
  vi: 'vie', // Vietnamese
  zh: 'zho', // Chinese
  'zh-hans': 'zhs', // Simplified Chinese
}
